import { fplIcon } from './fplIcon';
import { MediaIconLocal } from './MediaIcon';
import type { SvgComponent } from '@/types/SvgComponent';

/**
 * `icon.24.images` artwork at 64x64.
 *
 * FPL ships this glyph at 24 only, and `fplIcon` drops caller `width`/`height`, so `MediaIcon`
 * cannot hold the 64px size the design-app preview placeholders need. The 24 viewBox is kept so the
 * artwork scales rather than being cropped.
 */
const Media64IconFpl: SvgComponent = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="var(--fpl-icon-color, var(--color-icon))"
        d="M16.5 8A1.5 1.5 0 0 1 18 9.5v7a1.5 1.5 0 0 1-1.347 1.492L16.5 18h-7l-.153-.008a1.5 1.5 0 0 1-1.34-1.339L8 16.5v-7A1.5 1.5 0 0 1 9.5 8zm-7 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zm6-3a.5.5 0 0 1 0 1H8a1 1 0 0 0-1 1v7.5a.5.5 0 0 1-1 0V8a2 2 0 0 1 2-2zm-4.275 6.082a.5.5 0 0 1 .629.064l3 3a.5.5 0 1 1-.707.707L11.5 13.208l-.646.646a.5.5 0 1 1-.707-.707l1-1zM14.5 10.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
      />
    </svg>
  );
};

/**
 * Flag off renders the legacy `MediaIcon` artwork, so callers must keep passing the size they used
 * before (64). Flag on ignores those props and renders the FPL glyph at its own 64.
 */
export const Media64Icon = fplIcon(MediaIconLocal, Media64IconFpl);
